import type { FaireProductEntity } from "../../entity_types/product";

export const p_feznkffs5w: FaireProductEntity = {
  token: "p_feznkffs5w",
  type: "product",
  name: "Chorizo Ibérico",
  brandToken: "b_vbqxxxsbvs",
  brandName: "Mercado Famous",
  imageUrl:
    "https://cdn.faire.com/fastly/f676dae0105146db27a589a4c396106496d4e1d1466bee960d194413c7d6f8e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f9d1c6b3e71c3751276ad861b32252a3905a17efeb960e36512b63777aeeda4d.jpeg",
    "https://cdn.faire.com/fastly/cc1ede876a25bb9664cc1ef4679000df0e93b3124a277f9de4dbf687b0c41926.jpeg",
    "https://cdn.faire.com/fastly/3221f2594435c6135040bec6a8071e7a87be1373e1cc91dacb2edf6bae31d750.jpeg",
    "https://cdn.faire.com/fastly/cb238e2af6622556e11956072abc206b74698b0feb57f9a5ddcff95e21f5e774.jpeg",
  ],
  priceDollars: 10.98,
  description:
    "Mercado Famous Chorizo Iberico is a mild, juicy, and delectable Spanish cured sausage- It is the perfect meat for charcuterie, snacking, and sandwiches. We recommend pairing Mercado Famous Chorizo Iberico with robust red wine, hard ciders, cheddar cheese, and mimosas! \n\nThe Chorizo Iberico slices are made from the finest cuts of the Iberico Ham, and cured for 40 days in La Alberca, Spain. Our product comes from a century old family farm in Salamanca, Spain. Our pigs roam free across a protected reservation  of meadow and forrest, and are fed on acorns, natural pastures and other organic foods. We believe happy pigs, happy meats. \n\nChorizo Iberico comes pre sliced, vacuum sealed and ready to eat. It is shelf stable, and does not require refrigeration util the pack is opened. One pack contains 2 servings of Chorizo Iberico. \n\nIngredients: Pork Meat, Salt, Pimenton, Dextrin, Dextrose, Garlic, Oregano \nGluten Free, Lactose Free, No Nitrites or Nitrates Added \n",
  tags: [],
  msrpDollars: 21.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:21.946Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
